import type { PullUpDeviceState } from '@/core/DevicePull/DevicePullUpTask'

export enum GuideType {
  NO_DEVICE,
  NO_CONNECTION,
}

interface GuideListener {
  onShowGuide(type: GuideType, deviceId?: string, pullUpConfigState?: PullUpDeviceState): void
}

interface InternalGuideManager {
  showDeviceGuide(): void

  showConnectGuide(deviceId: string, pullUpDeviceState?: PullUpDeviceState): void
}

export class GuideManager {
  #guideListener: GuideListener | undefined

  setChangeListener(listener: GuideListener): void {
    this.#guideListener = listener
  }

  #showGuide(type: GuideType, deviceId?: string, pullUpConfigState?: PullUpDeviceState): void {
    this.#guideListener?.onShowGuide(type, deviceId, pullUpConfigState)
  }

  showDeviceGuide(): void {
    const type = GuideType.NO_DEVICE

    this.#showGuide(type)
  }

  showConnectGuide(deviceId: string, pullUpDeviceState: PullUpDeviceState): void {
    const type = GuideType.NO_CONNECTION

    this.#showGuide(type, deviceId, pullUpDeviceState)
  }

  get internalInstance(): InternalGuideManager {
    return {
      showDeviceGuide: () => this.showDeviceGuide(),
      showConnectGuide: (deviceId: string, pullUpDeviceState: PullUpDeviceState) =>
        this.showConnectGuide(deviceId, pullUpDeviceState),
    }
  }
}

const INSTANCE = new GuideManager()

export { INSTANCE }
